import type { Currency as WalletCurrency } from "@opensea/wallet"
import type { Currency } from "../providers/ClientProviders/client-providers-query"
import { memoizeOne } from "./memoization"

function toWalletCurrency(currency: Currency): WalletCurrency {
  return {
    ...currency,
    imageUrl: currency.imageUrl ?? "", // TODO: Make this non-null on BE
    isSwapDisabled: currency.isSwapDisabled,
    restrictSwapsToNativeTokens: currency.restrictSwapsToNativeTokens ?? false,
    restrictSwapsToSameChain: currency.restrictSwapsToSameChain ?? false,
  }
}

function toWalletCurrencies(
  currencies: Currency[],
): WalletCurrency[] | undefined {
  if (!currencies.length) {
    return undefined
  }
  return currencies.map(toWalletCurrency)
}

// Prevents unnecessarily updating wagmi config mid-session when navigating and currencies reference changes
// When wagmi config changes mid-session, connectors list is reset and injected connectors are removed
const memoizedToWalletCurrencies = memoizeOne(toWalletCurrencies)

export { memoizedToWalletCurrencies as toWalletCurrencies }
